import axios from 'axios';
import { API_URL, API_KEY, ENDPOINTS } from '../lib/constants';
import type { ParseDocResult } from '../types/parseDoc';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  timeout: 300000, // 5 minutes timeout for file uploads
  headers: {
    'x-api-key': API_KEY,
    // Don't set Content-Type here - let axios set it automatically based on data type
    // For FormData, axios will set multipart/form-data with boundary
    // For JSON, axios will set application/json
  },
});

// Parse document and get JSON output (OpenRouter only)
// File is sent directly, no temporary storage
export const parseDocument = async (
  systemPrompt: string,
  file: File
): Promise<ParseDocResult> => {
  try {
    if (!file) {
      throw new Error('File is required');
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('systemPrompt', systemPrompt || '');

    const response = await api.post<ParseDocResult>(
      ENDPOINTS.PARSEDOC_PARSE,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 300000, // 5 minutes for large files
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error parsing document:', error);
    throw error;
  }
};
